import { Component, OnInit } from '@angular/core';
import { SpotTemplateService } from '../services/spot-template.service';
import { environment } from '../../../../environments/environment';
import {  MatDialogRef } from '@angular/material/dialog';
import { ExtensionType } from '../../spots/model/extensionType';

@Component({
  selector: 'app-template-detail',
  templateUrl: './template-detail.component.html',
  styleUrl: './template-detail.component.scss'
})
export class TemplateDetailComponent implements OnInit {
  public template: any;
  public baseUrl= null;
  public xmlTemplateProperty = null;
  public templateDescriptionPictureUrl = null;
  public videoUrl = null;
  public muted = true;
  public seeNext = true;
  constructor(
    public spotTemplate$: SpotTemplateService,
    public dialogRef: MatDialogRef<TemplateDetailComponent>,
 
  ) {
      this.baseUrl = environment.apiBaseUrl;
  }

  ngOnInit(): void {
    this.spotTemplate$.getTemplateProperties(this.template.id,null).subscribe((res: any)=>{
      this.xmlTemplateProperty = res.xmlPropertyTemplates;
      let stepNumber=1;
      this.xmlTemplateProperty.forEach(property => {
        property.step = stepNumber;
        stepNumber = stepNumber + 1;
      });
      
      
      // retrouver le format preview pour la vidéo
      res.spotFormats.forEach(format => {
        if(format.formatType.id == 49){
          this.videoUrl = `${this.baseUrl}/file/getFile/${format.waitingFile.storageId}/${format.waitingFile.storageId}`;
        }
      });
   
      if(this.videoUrl.indexOf('mp4') == -1){
        // Lien de l'image de démo
        if(res.templateDescriptionPicture.extensionType == 0) {
          this.templateDescriptionPictureUrl = this.baseUrl + '/file/getFile/' + res.templateDescriptionPicture.storageId +'/' +res.templateDescriptionPicture.fileName;
        }
      }
      var mediaVideo = document.getElementById("mediaVideo");
      // Écoute lorsque la vidéo est prête à être lue sans interruption
      mediaVideo.addEventListener('loadeddata', function() {
        mediaVideo.style.opacity = "1";
        mediaVideo.style.display = "block";
        document.getElementById("videoSpinner").style.display = "none";
      });
    })

    
  }


  close(booleanValue: boolean){
    if(booleanValue){
      this.dialogRef.close(true);
    }
    else{
      this.dialogRef.close(false);
    }
  }

  public errorOnVideo() {
    let video = document.getElementById('mediaVideo');
    video.style.display = 'none';

    // let parentElemnt = video.parentElement;
    // let parentNode = video.parentNode;
  }
}
